import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { Box } from 'react-native-flex-layout';

export default class LegendItem extends React.Component {
  render() {
    const { title, color } = this.props;
    return (
      <Box style={styles.container}>
        <View style={[styles.colorBar, { backgroundColor: color }]} />
        <Text style={styles.label}>{title}</Text>
      </Box>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    paddingVertical: 4,
  },
  // V3: Rounded color indicator
  colorBar: {
    height: 10,
    width: 32,
    marginRight: 8,
    borderRadius: 2,
  },
  // V3: Consistent legend label typography
  label: {
    fontSize: 13,
    color: '#374151',
  },
});
